import { render } from "./OrderDeliverablesAndQc.vue?vue&type=template&id=3db56266&ts=true"
import script from "./OrderDeliverablesAndQc.vue?vue&type=script&lang=ts"
export * from "./OrderDeliverablesAndQc.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__